import EarlyBirdCorporateCard from './EarlyBirdCorporateCard';

export default EarlyBirdCorporateCard;



// WEBPACK FOOTER //
// ./src/components/EarlyBirdCorporateCard/index.js